import React, { useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CustomToolbar from '../../common/datagrid/CustomToolbar';
import CustomLoadingOverlay from '../../common/datagrid/CustomLoadingOverlay';

const ApprovalList = ({
  apiRef,
  columns,
  rows,
  error,
  loading,
  handleRowClick,
}) => {
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ flexGrow: 1 }}>
        <DataGridPro
          autoHeight
          apiRef={apiRef}
          rows={rows ? rows : []}
          columns={columns}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: CustomLoadingOverlay,
          }}
          componentsProps={{
            toolbar: { fileName: '결재_리스트' },
          }}
          loading={loading}
          onRowClick={handleRowClick}
          // pageSize={pageSize}
          // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          // rowsPerPageOptions={[5, 10, 20, 50, 100]}
          // pagination
        />
      </div>
    </div>
  );
};

export default ApprovalList;
